import { getSingle, getDocs } from "shared/prismic";
import { PeopleOverviewPage } from "containers/PeopleOverviewPage";

export async function getStaticProps({ preview = null, previewData }) {
  const doc = await getSingle({ previewData, type: "coach_overview" });
  const people = await getDocs({ previewData, type: "coach_detail" });
  const filters = { region: "Alle provincies", type: "Alle soorten" };

  return { props: { doc, people, preview, filters } };
}

export default PeopleOverviewPage;
